/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import './AppDetails.scss';
import { CopyText } from '../../../UiKit';

export const AppDetails = ({ appDetails, deviceDetails }) => {
  return (
    <div>
      {appDetails?.map((item, index) => (
        <React.Fragment key={`${item.title}-${index}`}>
          <div className='tw-grid tw-grid-cols-1 tw-border tw-border-solid tw-border-grey-200 tw-rounded-lg'>
            <div className='tw-flex tw-flex-col'>
              {[
                {
                  key: 'Device ID',
                  value: deviceDetails?.device_id,
                  isId: true,
                },
                {
                  key: 'Device Block Status',
                  value: deviceDetails?.is_blocked ? 'Blocked' : '-',
                  isId: false,
                },
                { key: 'Device OS', value: item.title, isId: false },
                { key: 'App', value: item.subtitle, isId: false },
              ].map((info) => {
                if (!info) return null;
                return (
                  <InfoStrip
                    key={info.key}
                    title={info.key}
                    value={info.value}
                    isId={info.isId}
                  />
                );
              })}
            </div>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

const InfoStrip = ({ title, value, isId, idUrl }) => {
  return (
    <div className='tw-w-full tw-flex tw-justify-start tw-items-center'>
      <span className='tw-text-lg tw-w-64 tw-p-3 tw-font-medium tw-text-zinc-700 tw-border tw-border-solid !tw-border-y-0  !tw-border-l-0 tw-border-grey-200 tw-leading-none'>
        {title || '-'}
      </span>
      <span
        onClick={() => {
          if (idUrl) {
            window.open(idUrl, '_blank', 'noopener,noreferrer');
          }
        }}
        className={`tw-font-medium tw-h-10 tw-flex tw-items-center tw-justify-start tw-leading-none ${
          isId
            ? 'tw-mx-3 tw-mt-2 tw-p-2 !tw-w-fit tw-whitespace-nowrap tw-leading-none tw-bg-grey-200/70 tw-rounded-lg tw-text-zinc-700 tw-text-[1.4rem]'
            : 'tw-text-sm tw-text-zinc-700 tw-p-3'
        }`}
      >
        {isId && value && value !== 'Blocked' ? (
          <CopyText title={value || '-'} />
        ) : value === 'Blocked' ? (
          <span className='tw-text-white tw-p-2 tw-rounded-lg tw-bg-[#FF0000] tw-mt-1'>
            Blocked
          </span>
        ) : (
          value || '-'
        )}
      </span>
    </div>
  );
};
